import { useQuery } from 'react-query';
import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';

import type { ILeadRoutingRule } from 'src/services/api/lead-routing-rules/types';
import { LEAD_ROUTING_RULES_PATH } from 'src/services/api/lead-routing-rules/path';

interface IGetLeadRoutingRulesResponse {
    rules: ILeadRoutingRule[];
}

export const useLeadRoutingRules = () => {
    return useQuery(
        queryKeys.leadRoutingRules,
        async () => {
            const res = await apiClient(LEAD_ROUTING_RULES_PATH)
                .json<IGetLeadRoutingRulesResponse>();
            return res.rules;
        }
    );
};
